export const DEFAULT_IMAGE_COMPONENT_SOURCE = 'https://i.imgur.com/CssjnzU.png';
